"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _auth = require("@/utils/auth");
var _wxApi = require("@/api/wxApi");
var _systemSetting = require("@/api/systemSetting");
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'Index',
  components: {},
  data: function data() {
    var _this2 = this;
    var validateContent = function validateContent(rule, value, callback) {
      if (_this2.formValidate.type === 'text') {
        if (_this2.formValidate.contents.content === '') {
          callback(new Error('请填写规则内容'));
        } else {
          callback();
        }
      }
    };
    var validateSrc = function validateSrc(rule, value, callback) {
      if (_this2.formValidate.type === 'image' && _this2.formValidate.contents.mediaId === '') {
        callback(new Error('请上传'));
      } else {
        callback();
      }
    };
    var validateVal = function validateVal(rule, value, callback) {
      if (_this2.labelarr.length === 0) {
        callback(new Error('请输入后回车'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      visible: false,
      grid: {
        xl: 7,
        lg: 12,
        md: 10,
        sm: 24,
        xs: 24
      },
      delfromData: {},
      isShow: false,
      maxCols: 3,
      scrollerHeight: '600',
      contentTop: '130',
      contentWidth: '98%',
      modals: false,
      val: '',
      formatImg: ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
      formatVoice: ['mp3', 'wma', 'wav', 'amr'],
      header: {},
      formValidate: {
        status: true,
        type: '',
        keywords: '',
        contents: {
          content: '',
          articleData: {},
          mediaId: '',
          srcUrl: '',
          articleId: null
        },
        id: null
      },
      ruleValidate: {
        val: [{
          required: true,
          validator: validateVal,
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择消息类型',
          trigger: 'change'
        }],
        content: [{
          required: true,
          validator: validateContent,
          trigger: 'blur'
        }],
        mediaId: [{
          required: true,
          validator: validateSrc,
          trigger: 'change'
        }]
      },
      labelarr: [],
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      }
    };
  },
  computed: {
    fileUrl: function fileUrl() {
      return https + "/wechat/reply/upload/image";
    },
    voiceUrl: function voiceUrl() {
      return https + "/wechat/reply/upload/voice";
    },
    httpsURL: function httpsURL() {
      return process.env.VUE_APP_BASE_API.replace('api/', '');
    }
  },
  watch: {
    $route: function $route(to, from) {
      if (this.$route.params.id) {
        // this.formValidate.keywords = this.$route.params.key
        if ((0, _permission.checkPermi)(['platform:wechat:public:keywords:reply:info'])) this.details();
      } else {
        // this.labelarr = []
        // this.$refs['formValidate'].resetFields()
      }
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      if ((0, _permission.checkPermi)(['platform:wechat:public:keywords:reply:info'])) this.details();
    }
    if (this.$route.path.indexOf('keyword') === -1) {
      if ((0, _permission.checkPermi)(['platform:wechat:public:keywords:reply:info:keywords'])) this.followDetails();
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
    },
    change: function change(e) {
      this.$forceUpdate();
    },
    // 上传
    handleUploadForm: function handleUploadForm(param) {
      var _this3 = this;
      var formData = new FormData();
      formData.append('media', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _systemSetting.wechatUploadApi)(formData, {
        type: this.formValidate.type === 'image' ? 'image' : 'voice'
      }).then(function (res) {
        loading.close();
        _this3.formValidate.contents.mediaId = res.mediaId;
        _this3.formValidate.contents.srcUrl = res.url;
        _this3.$message.success('上传成功');
      }).catch(function () {
        loading.close();
      });
    },
    changePic: function changePic() {
      var _this = this;
      this.$modalArticle(function (row) {
        _this.formValidate.contents.articleData = {
          title: row.title,
          imageInput: row.imageInput
        };
        _this.formValidate.contents.articleId = row.id;
      });
    },
    handleClosePic: function handleClosePic() {
      this.visible = false;
    },
    // 详情
    details: function details() {
      var _this4 = this;
      this.loading = true;
      (0, _wxApi.wechatReplyInfoApi)(this.$route.params.id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var info;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                info = res || null;
                _this4.formValidate = {
                  status: info.status,
                  type: info.type,
                  keywords: info.keywords,
                  id: info.id,
                  contents: {
                    content: JSON.parse(info.data).content,
                    mediaId: JSON.parse(info.data).mediaId,
                    srcUrl: JSON.parse(info.data).srcUrl,
                    articleData: JSON.parse(info.data).articleData
                  }
                };
                _this4.labelarr = info.keywords.split(',') || [];
                _this4.loading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {
        _this4.loading = false;
      });
    },
    // 关注回复，无效关键词详情
    followDetails: function followDetails() {
      var _this5 = this;
      this.loading = true;
      (0, _wxApi.keywordsInfoApi)({
        keywords: this.$route.path.indexOf('follow') !== -1 ? 'subscribe' : 'default'
      }).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          var info;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                info = res || null;
                _this5.formValidate = {
                  status: info.status,
                  type: info.type,
                  keywords: info.keywords,
                  data: '',
                  id: info.id,
                  contents: {
                    content: JSON.parse(info.data).content || '',
                    mediaId: JSON.parse(info.data).mediaId || '',
                    srcUrl: JSON.parse(info.data).srcUrl || '',
                    articleData: JSON.parse(info.data).articleData || {}
                  }
                };
                _this5.loading = false;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function () {
        _this5.loading = false;
        // if (res.message === '数据不存在') return
        // this.$message.error(res.message)
      });
    },
    // 下拉选择
    RuleFactor: function RuleFactor(type) {
      switch (type) {
        case 'text':
          this.formValidate.contents.mediaId = '';
          this.formValidate.contents.srcUrl = '';
          this.formValidate.contents.articleData = {};
          break;
        case 'news':
          this.formValidate.contents.mediaId = '';
          this.formValidate.contents.content = '';
          this.formValidate.contents.srcUrl = '';
          this.formValidate.contents.articleData = {};
          break;
        default:
          this.formValidate.contents.content = '';
          this.formValidate.contents.mediaId = '';
          this.formValidate.contents.articleData = {};
      }
      // this.$refs['formValidate'].resetFields();
    },
    handleClose: function handleClose(tag) {
      var index = this.labelarr.indexOf(tag);
      this.labelarr.splice(index, 1);
    },
    addlabel: function addlabel() {
      var count = this.labelarr.indexOf(this.val);
      if (count === -1) {
        this.labelarr.push(this.val);
      }
      this.val = '';
    },
    // 保存
    submenus: (0, _validate.Debounce)(function (name) {
      var _this6 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this6.formValidate.keywords = _this6.labelarr.join(',');
          _this6.formValidate.data = JSON.stringify(_this6.formValidate.contents);
          if (_this6.$route.path.indexOf('keyword') !== -1) {
            _this6.formValidate.id = _this6.$route.params.id || '';
            _this6.$route.params.id ? (0, _wxApi.wechatReplyUpdateApi)(_this6.formValidate).then(/*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _this6.operation();
                    case 1:
                      return _context3.a(2);
                  }
                }, _callee3);
              }));
              return function (_x3) {
                return _ref3.apply(this, arguments);
              };
            }()).catch(function (res) {
              _this6.$message.error(res.message);
            }) : (0, _wxApi.wechatReplySaveApi)(_this6.formValidate).then(/*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _this6.operation();
                    case 1:
                      return _context4.a(2);
                  }
                }, _callee4);
              }));
              return function (_x4) {
                return _ref4.apply(this, arguments);
              };
            }()).catch(function (res) {
              _this6.$message.error(res.message);
            });
          } else {
            _this6.$route.path.indexOf('follow') !== -1 ? _this6.formValidate.keywords = 'subscribe' : _this6.formValidate.keywords = 'default';
            _this6.formValidate.id !== null ? (0, _wxApi.wechatReplyUpdateApi)(_this6.formValidate).then(/*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(res) {
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      _this6.$message.success('操作成功');
                    case 1:
                      return _context5.a(2);
                  }
                }, _callee5);
              }));
              return function (_x5) {
                return _ref5.apply(this, arguments);
              };
            }()) : (0, _wxApi.wechatReplySaveApi)(_this6.formValidate).then(/*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(res) {
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.n) {
                    case 0:
                      _this6.operation();
                    case 1:
                      return _context6.a(2);
                  }
                }, _callee6);
              }));
              return function (_x6) {
                return _ref6.apply(this, arguments);
              };
            }()).catch(function (res) {
              _this6.$message.error(res.message);
            });
          }
        } else {
          return false;
        }
      });
    }),
    // 保存成功操作
    operation: function operation() {
      var _this7 = this;
      this.$modalSure('继续添加').then(function () {
        setTimeout(function () {
          _this7.labelarr = [];
          _this7.val = '';
          _this7.$refs['formValidate'].resetFields();
          _this7.formValidate.contents.mediaId = '';
        }, 1000);
      }).catch(function () {
        setTimeout(function () {
          _this7.$router.push({
            path: "/operation/application/publicAccount/wxReply/keyword"
          });
        }, 500);
      });
    }
  }
};